import { useState } from "react";
import { Button, Modal, Tabs } from "antd";
import { FileTextOutlined } from "@ant-design/icons";

export const SubmissionLogs = ({ console_log_tail }) => {
  const [showLogs, setShowLogs] = useState(false);

  if (!console_log_tail) {
    return null;
  }
  const items = Object.entries(JSON.parse(console_log_tail)).map(([key, text]) => ({
    key: key,
    label: key,
    children: (
      <div
        style={{
          height: "65vh",
        }}
      >
        <pre
          style={{
            fontSize: "12px",
            whiteSpace: "pre-wrap",
            wordWarp: "break-word",
            overflow: "auto",
            height: "auto",
            maxHeight: "100%",
            backgroundColor: "#eeeef4",
          }}
        >
          {text}
        </pre>
      </div>
    ),
  }));

  return (
    <>
      <Modal width="85%" open={showLogs} footer={null} onCancel={() => setShowLogs(false)}>
        <Tabs items={items} />
      </Modal>
      <Button
        type="link"
        style={{
          width: "100%",
          height: "100%",
          padding: 0,
          display: "inline-block",
          color: "grey",
          overflow: "hidden",
        }}
        onClick={() => setShowLogs(true)}
      >
        <FileTextOutlined />
      </Button>
    </>
  );
};
